document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCifras();
  initGaleriaProducto();
  initVariantes();
  initQty();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-mt-delay') || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, parseInt(delay, 10));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initCifras() {
  var els = document.querySelectorAll('[data-mt-cifra]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-mt-cifra'));
      var suffix = el.getAttribute('data-mt-suffix') || '';
      if (reduced || isNaN(target)) {
        el.textContent = target + suffix;
      } else {
        var start = null;
        var duration = 1400;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var val = target * eased;
          el.textContent = (Number.isInteger(target) ? Math.round(val) : val.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galleries = document.querySelectorAll('[data-mt-galeria]');
  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-mt-galeria-main]');
    var thumbs = gallery.querySelectorAll('[data-mt-galeria-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-mt-full');
        var alt = thumb.getAttribute('data-mt-alt') || '';
        if (full) {
          main.querySelector('img').setAttribute('src', full);
          main.querySelector('img').setAttribute('alt', alt);
        }
        thumbs.forEach(function (t) { t.classList.remove('mt-active'); });
        thumb.classList.add('mt-active');
      });
    });
  });
}

function initVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-mt-precio-actual]');
    var compareEl = form.querySelector('[data-mt-precio-antes]');
    var addBtn = form.querySelector('[data-mt-add-btn]');
    var stockEl = form.querySelector('[data-mt-stock]');
    var optionButtons = form.querySelectorAll('[data-mt-option]');
    var selected = {};

    optionButtons.forEach(function (btn) {
      if (btn.classList.contains('mt-active')) {
        selected[btn.getAttribute('data-mt-option-name')] = btn.getAttribute('data-mt-option-value');
      }
    });

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function actualizar() {
      var match = variantes.find(function (v) {
        return Object.keys(selected).every(function (k) {
          return v.options[k] === selected[k];
        });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compareAtPrice && match.compareAtPrice > match.price) {
          compareEl.textContent = money(match.compareAtPrice);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.getAttribute('data-mt-label-disponible') : addBtn.getAttribute('data-mt-label-agotado');
      }
      if (stockEl) {
        stockEl.textContent = match.available ? stockEl.getAttribute('data-mt-label-disponible') : stockEl.getAttribute('data-mt-label-agotado');
      }
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-mt-option-name');
        form.querySelectorAll('[data-mt-option-name="' + name + '"]').forEach(function (b) {
          b.classList.remove('mt-active');
        });
        btn.classList.add('mt-active');
        selected[name] = btn.getAttribute('data-mt-option-value');
        actualizar();
      });
    });

    if (optionButtons.length) actualizar();
  });
}

function initQty() {
  document.querySelectorAll('[data-mt-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-mt-qty-minus]');
    var plus = wrap.querySelector('[data-mt-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    plus && plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
}
